module.exports = __webpack_public_path__ + "static/img/3.b4af3d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/3.png
// module id = WkG6
// module chunks = 0